<template>
<div>
  <div class="screen-message">
    <div class="message-item text-center">
      <h1>404
        <span>Page Not Found</span>
      </h1>
      <p>お探しのページが見つかりませんでした。</p>
      <div class="back-button">
        <router-link :to="{name: 'top'}">トップに戻る</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {}
</script>
